export const contactPageContent = {
  en: {
    title: "Contact",
    contact: {
      name: "Revimo Team:",
      email: "Email:",
      support: "Support:",
      location: "Location:",
      locationACC: "Maribor, Slovenia",
      responseTime: "Response time:",
      responseTimeValue: "Usually within 1–2 business days",
    },
    topicsTitle: "What you can contact us about",
    topics: {
      support: "Product support",
      supportValue: "Login issues, bugs, training plans, and platform questions",
      business: "Business",
      businessValue: "Partnerships, collaborations, media, and startup opportunities",
      feedback: "Feedback",
      feedbackValue: "Feature requests, UX suggestions, and improvements",
    },
    optionsTitle: "Contact options",
    options: {
      general: "General",
      support: "Support",
    },
  },
  sl: {
    title: "Kontakt",
    contact: {
      name: "Ekipa Revimo:",
      email: "E-pošta:",
      support: "Podpora:",
      location: "Lokacija:",
      locationACC: "Maribor, Slovenija",
      responseTime: "Odzivni čas:",
      responseTimeValue: "Običajno odgovorimo v 1–2 delovnih dneh",
    },
    topicsTitle: "Za kaj nas lahko kontaktirate",
    topics: {
      support: "Podpora za izdelek",
      supportValue: "Težave s prijavo, napake, trening načrti in vprašanja o platformi",
      business: "Poslovno",
      businessValue: "Partnerstva, sodelovanja, mediji in startup priložnosti",
      feedback: "Povratne informacije",
      feedbackValue: "Predlogi za funkcionalnosti, UX predlogi in izboljšave",
    },
    optionsTitle: "Možnosti kontakta",
    options: {
      general: "Splošno",
      support: "Podpora",
    },
  },
} as const;